import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./screen/Dashboard";
import Login from "./screen/Login";
import AdminPanel from "./screen/AdminPanel";
import Reports from "./screen/Reports";
import Notifications from "./screen/Notifications";
import Settings from "./screen/Settings";
import ChangePassword from "./screen/ChangePassword";
import ForgotPassword from "./screen/ForgotPassword";
import VerifyOTP from "./screen/VerifyOTP";
import ResetPassword from "./screen/ResetPassword";
import Album from "./screen/album";
import NewAlbum from "./screen/NewAlbum";
import EditAlbum from "./screen/EditAlbum";
import Chapter from "./screen/chapters";
import NewChapter from "./screen/NewChapter";
import EditChapter from "./screen/EditChapter";
import Sidebar from "./screen/sidebar";
import { Outlet } from "react-router-dom";
import Bulk_upload from "./screen/Bulk_upload";
import Bulk_table from "./screen/Bulk_table";
import Content from "./screen/Content"
import NewContent from "./screen/NewContent"
import LogTable from "./screen/log_table";
import EditContent from "./screen/EditContent"
import Characters from "./screen/Characters"
import NewCharacters from "./screen/NewCharacters"
import EditCharacters from "./screen/EditCharacters"
import ViewContent from "./screen/ViewContent"
import Radio from "./screen/radio/radio"
import Sleep from "./screen/sleep/sleep"
import FeedbackList from "./screen/Feedback.js"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Report from "./screen/reports/report.js"
const Layout = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};

function App() {
  return (
    <Router>
      <>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<Layout />}>
          <Route path="/user-list" element={<Dashboard />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/album" element={<Album />} />
          <Route path="/new-album" element={<NewAlbum />} />
          <Route path="/edit-album/:id" element={<EditAlbum />} />
          <Route path="/chapters" element={<Chapter />} />
          <Route path="/new-chapter" element={<NewChapter />} />
          <Route path="/edit-chapter/:id" element={<EditChapter />} />
          <Route path="/bulk_upload" element={<Bulk_upload />} />
          <Route path="/bulk_table" element={<Bulk_table />} />
          <Route path="/log" element={<LogTable />} />
          <Route path="/content" element={<Content />} />
          <Route path="/new-content" element={<NewContent />} />
          <Route path="/edit-content/:id" element={<EditContent />} />
          <Route path="/characters" element={<Characters />} />
          <Route path="/new-characters" element={<NewCharacters />} />
          <Route path="/edit-character/:id" element={<EditCharacters />} />
          <Route path="/view-content/:id" element={<ViewContent />} />
          <Route path="/radio" element={<Radio />} />
          <Route path="/radio/*" element={<Radio />} />
          <Route path="/sleep" element={<Sleep />} />
          <Route path="/sleep/*" element={<Sleep />} />
          <Route path="/feedback" element={<FeedbackList />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/report" element={<Report />} />
          <Route path="/report/*" element={<Report />} />

        {/* <Route path="edit-slot/:slot_id" element={<EditSlot />} /> */}

          </Route>

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOTP />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        {/* <Route path="/change-password" element={<ChangePassword />} /> */}
      </Routes>
      <ToastContainer position="top-right" autoClose={3000} />
      </>
    </Router>
  );
}

export default App;
